import React from "react";
import { Typography, Box, IconButton } from "@mui/material";
import { Close, ContentCopy } from "@mui/icons-material";
import MzButton from "@markaaz/ui/MzButton";
import MzInput from "@markaaz/ui/MzInputControls";
import MzTooltip from "@markaaz/ui/MzTooltip";
import { EditIcon, Download, UploadFileIcon } from "../../assets/icons";

const sx = {
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "60px"
  },
  inputBox: {
    width: "720px"
  },
  rowContent: {
    color: "blue.c100",
    gap: "15px",
    display: "flex",
    alignItems: "center"
  },
  rowLabel: {
    color: "darkBlue.c100",
    width: "220px"
  },
  inputFile: {
    display: "none"
  },
  icon: {
    color: "blue.c100"
  },
  key: {
    color: "darkBlue.c100",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    height: "28px",
    width: "145px",
    backgroundColor: "blue.c20",
    borderRadius: "8px",
    padding: "4px 8px 4px 8px"
  },
  closeIcon: {
    height: "8px",
    width: "8px",
    color: "darkBlue.c100"
  },
  uploadButtonAlignment: {
    justifyContent: "stretch",
    gap: "111px"
  }
};

export default function DetailsRow({
  label,
  inputName,
  values,
  rowData,
  fileUrl,
  fileInputRef,
  isConnection,
  isKeys,
  isMarkaazHosted,
  isPartnerHosted,
  showInputBox,
  showEditButton,
  showCopyButton,
  showUploadButton,
  onInputChange,
  onEdit,
  onDownload,
  onFileRemove,
  onUpload,
  onFileInput,
  fileName
}) {
  function appendExtensionWithFileName(fileName) {
    if (typeof fileName === "string") {
      const extension = fileName.substring(fileName.lastIndexOf("."));
      if (extension && extension !== fileName) {
        return `Public-Key-File${extension}`;
      }
    }
    return "No keys found";
  }

  return (
    <>
      {isConnection && (
        <Box sx={sx.row}>
          <Typography variant="body1" sx={sx.rowLabel}>
            {label}
          </Typography>
          {showInputBox && (
            <Box sx={sx.inputBox}>
              <MzInput
                name={inputName}
                fullWidth
                value={values || ""}
                onChange={(e) => {
                  const newValue = e.target.value;
                  onInputChange(inputName, newValue !== "" ? newValue : null);
                }}
              />
            </Box>
          )}
          {!showInputBox && (
            <Box sx={sx.rowContent}>
              <Typography variant="body2">
                {values !== undefined && values !== "" ? values : rowData.toString()}
              </Typography>
              {showEditButton && (
                <IconButton onClick={() => onEdit(inputName)} sx={sx.icon}>
                  <EditIcon />
                </IconButton>
              )}
              {showCopyButton && (
                <MzTooltip placement="top" title="Copy">
                  <IconButton onClick={() => navigator.clipboard.writeText(rowData)} sx={sx.icon}>
                    <ContentCopy />
                  </IconButton>
                </MzTooltip>
              )}
            </Box>
          )}
        </Box>
      )}
      {isKeys && (
        <Box sx={isMarkaazHosted && showUploadButton ? { ...sx.row, ...sx.uploadButtonAlignment } : sx.row}>
          <Typography variant="body1">{label}</Typography>
          {isPartnerHosted && (
            <Box sx={sx.rowContent}>
              <Typography variant="body2">{appendExtensionWithFileName(fileName)}</Typography>
              {fileName && (
                <MzTooltip placement="top" title="Download">
                  <IconButton color="primary" onClick={() => onDownload(fileUrl)}>
                    <Download />
                  </IconButton>
                </MzTooltip>
              )}
            </Box>
          )}
          {isMarkaazHosted && (
            <Box>
              {!showUploadButton ? (
                <Box sx={sx.key}>
                  <Typography variant="body2">Public-Key-File</Typography>
                  <IconButton onClick={onFileRemove} sx={sx.closeIcon}>
                    <Close />
                  </IconButton>
                </Box>
              ) : (
                showUploadButton && (
                  <Box>
                    <MzButton variant="outlined" color="secondary" size="large" onClick={onUpload}>
                      <UploadFileIcon /> &nbsp; Upload a File
                    </MzButton>
                    <input
                      type="file"
                      accept=".pem, .ppk,"
                      ref={fileInputRef}
                      style={sx.inputFile}
                      onChange={onFileInput}
                    />
                  </Box>
                )
              )}
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
